import React from 'react';
import PropTypes from 'prop-types';

const Couples = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={25} fill="none" viewBox="0 0 26 25" {...props}>
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M7.286 15.268v2.525l-4.504 1.634C1.702 19.818 1 20.852 1 22.01v1.725h17.143V22.01c0-1.157-.704-2.19-1.782-2.582l-4.503-1.634v-2.67"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M13.97 10.482c0 3.03-2.02 5.486-4.512 5.486-2.492 0-4.511-2.456-4.511-5.486 0-3.028 2.02-5.481 4.511-5.481 2.49 0 4.511 2.453 4.511 5.481Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M13.934 9.988c-.15.02-.275.008-.427.038-1.538.3-2.524-.264-3.371-1.764-.507.986-2.092 1.764-3.396 1.764-.641 0-1.194-.133-1.746-.427"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.036 23.734H25V22.01c0-1.157-.703-2.19-1.781-2.582l-4.504-1.634v-2.67"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.316 5c2.491 0 4.511 2.455 4.511 5.482 0 3.03-2.02 5.485-4.511 5.485"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.791 9.988c-.15.02-.275.008-.427.038-1.538.3-2.524-.264-3.37-1.764"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="m14 1.938-.211-.313C13.544 1.262 13.183 1 12.75 1c-.692 0-1.25.628-1.25 1.406 0 .29.078.56.211.781C11.936 3.567 14 6 14 6m0-4.063s0 .313.211-.312c.14-.414.606-.625 1.039-.625.692 0 1.25.628 1.25 1.406 0 .29-.078.56-.211.781C16.064 3.567 14 6 14 6"
    />
    <path fill={color} d="M14.2 1.67h.3v.3h-.3z" />
  </svg>
);

Couples.propTypes = {
  color: PropTypes.string
};

export default Couples;
